import * as sharedTypes from 'src/actions/shared/sharedTypes';
import backToListView from 'src/actions/shared/backToListView';
import createCollectionResource from 'src/actions/shared/createResource';
import { DomainError as StandardDomainError } from '@ad-scripts/application/lib/error';
import { Matches, ValidateIf, IsNotEmpty } from 'class-validator';
import { sortMergedSkills } from 'src/actions/skills/skillsUtils';
import { toastError, toastSuccess } from 'src/actions/toast';

export class Skill {
  id: string;
  disabled: boolean;

  @Matches(/\S/, { message: 'Please name your skill' })
  name: string;

  @ValidateIf(({ parentDropdownEnabled }) => parentDropdownEnabled === true)
  @IsNotEmpty({ message: 'Please select a parent skill' })
  parentId?: string;

  _version: number;
}

const skillsResource = createCollectionResource<Skill>({
  name: 'skills',
  endpoint: 'v1/orgs/:orgId/skills/:id',
  type: Skill,
  reducers: {
    dataMergeStarted(state) {
      state.dataMergeFinished = false;
    },
    dataMergeFinished(state, action) {
      state.dataMergeFinished = true;
      state.values = action.payload;
    },
  },
  observerCreator: ({ actions }) => {
    return ({ dispatch, getState }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
          updateSkillsWithHierarchies(dispatch, getState);
        },
      };
    };
  },
});

const { addStarted, addSuccess, addError, addRequestError } = skillsResource.actions;

const add: sharedTypes.AppThunk =
  (_, skill: Skill, opts?) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(addStarted({}));
      await gateways.skills.replace(skill);
      dispatch(addSuccess({}));

      backToListView();

      dispatch(toastSuccess(opts && opts.customToastMsg ? opts.customToastMsg : `Created Skill "${skill.name}"`));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(addError(err.errors));
      } else {
        dispatch(addRequestError(err));
      }
      dispatch(toastError('There was an error while adding'));
    }
  };

skillsResource.effects.add = add;

export function updateSkillsWithHierarchies(dispatch, getState) {
  const state = getState();
  const skills = sortMergedSkills(state);
  dispatch(skillsResource.actions.dataMergeFinished(skills));
}

export default skillsResource;
